// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"8e2c591d","495":"fc5ce410","788":"082a97ee"}[chunkId] + ".chunk.js";
};